import { render } from "./Livechat.vue?vue&type=template&id=a36651b6"
import script from "./Livechat.vue?vue&type=script&lang=js"
export * from "./Livechat.vue?vue&type=script&lang=js"
script.render = render

export default script